/**
 * FinlyLogo — Monograma "F" formado por barras ascendentes.
 *
 * - Stem vertical + dos brazos horizontales de distinta longitud que
 *   evocan un mini bar-chart (refuerza el dominio: finanzas + progreso).
 * - Un punto/barra acento en la esquina inferior derecha rompe la simetría
 *   y aporta un guiño a "tu dinero subiendo".
 * - Render 100% SVG inline, escala perfecto en cualquier tamaño y favicon.
 *
 * Props:
 *   size      px del lado del cuadrado contenedor (default 40)
 *   rounded   border-radius del cuadrado (default "20%", auth pages usan "16.6%")
 *   bg        color del fondo del cuadrado (default Trust Blue #0052FF)
 *   mark      color del trazo de la F (default white)
 *   accent    color del punto acento (default Neon Green #00D67A)
 *   showAccent muestra/oculta el punto acento (default true)
 *   shadow    aplica sombra suave (default false)
 *   className  clases extra para el wrapper
 */
export function FinlyLogo({
  size = 40,
  rounded = "20%",
  bg = "#8A9A5B", // Verde olivo suave (soft olive)
  mark = "#FFFFFF",
  accent = "#E6C875", // Mustard gold accent — complementa el olivo
  showAccent = true,
  shadow = false,
  className = "",
}) {
  const px = typeof size === "number" ? `${size}px` : size;
  return (
    <div
      className={`inline-flex items-center justify-center ${
        shadow ? "shadow-lg shadow-blue-500/20" : ""
      } ${className}`}
      style={{
        width: px,
        height: px,
        borderRadius: rounded,
        background: bg,
      }}
      data-testid="finly-logo"
      aria-label="Finly+"
      role="img"
    >
      <svg
        viewBox="0 0 100 100"
        width="62%"
        height="62%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Stem vertical de la F */}
        <rect x="10" y="8" width="18" height="84" rx="6" fill={mark} />
        {/* Brazo superior (más largo) */}
        <rect x="10" y="8" width="76" height="18" rx="6" fill={mark} />
        {/* Brazo medio (más corto) */}
        <rect x="10" y="42" width="54" height="18" rx="6" fill={mark} />
        {/* Punto acento (data point) — rompe simetría, sugiere progreso */}
        {showAccent && <circle cx="78" cy="80" r="10" fill={accent} />}
      </svg>
    </div>
  );
}

export default FinlyLogo;
